<template>
    <div class="align-items-center bg-light rounded px-0 p-5 border-primary p-mobile-small icon-text-container">
        <div class="row" :class="rowClass">
            <div
                :class="{
                    'col-7 col-md-8 col-lg-2': withTitle,
                    'col-md-2': !withTitle,
                }"
            >
                <slot name="icon"></slot>
            </div>
            <div
                v-if="withTitle"
                :class="{
                    'col-5 col-md-4 col-lg-2': withPriceLabel || titleWithoutPrice,
                    'col-md-4': !withPriceLabel && !titleWithoutPrice,
                }"
                class="icon-text-container-title"
            >
                <slot name="title"></slot>
            </div>
            <div
                :class="{
                    'col-12 col-md-12 col-lg-7': withPriceLabel || withTitle,
                    'col-md-10': !(withPriceLabel || withTitle),
                }"
            >
                <slot></slot>
            </div>
            <div
                v-if="withPriceLabel"
                :class="{
                    'col-12 col-md-12 col-lg-1': withTitle,
                    'col-md-4': !withTitle,
                }"
            >
                <slot name="price"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        rowClass: {
            type: String,
            required: false,
            default() {
                return null;
            },
        },
        withPriceLabel: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
        withTitle: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
        titleWithoutPrice: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
    },
};
</script>
<style lang="scss">
.icon-text-container .icon-text-container-title span {
    background-color: #595f66;
    color: #fff;
    font-family: var(--font);
    line-height: 1.5;
    font-weight: 600;
    font-size: 1rem;
    padding: 5px;
    border-radius: 0.25rem;
}
</style>
